import { TypeGuard } from '../../shared';
import { ChatDataTypes } from './chat-data';

export interface QueueCallsReport {
  queueCalls: QueueCallsData[];
  type: string;
}

export interface QueueCallsData {
  calls: number;
  group: string;
  longestWait: string;
  type: 'ibqueue-calls';
}

export const isIBQueued: TypeGuard<ChatDataTypes, QueueCallsReport> = (
  data: ChatDataTypes
): data is QueueCallsReport => (data && data.type === 'ibqueue-calls') || false;
